/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUrlaubsanspruchDto } from '../../models/update-urlaubsanspruch-dto';
import { UrlaubsanspruchDto } from '../../models/urlaubsanspruch-dto';

export interface UpdateUrlaubsanspruch$Plain$Params {

/**
 * ID des Urlaubsanspruch
 */
  id: string;
  
    /**
     * Aktualisierte Werte für den Urlaubsanspruch
     */
    body?: UpdateUrlaubsanspruchDto
}

export function updateUrlaubsanspruch$Plain(http: HttpClient, rootUrl: string, params: UpdateUrlaubsanspruch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsanspruchDto>> {
  const rb = new RequestBuilder(rootUrl, updateUrlaubsanspruch$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UrlaubsanspruchDto>;
    })
  );
}

updateUrlaubsanspruch$Plain.PATH = '/v1/urlaubsansprueche/{id}';
